import { createPcmStreamer as createLegacyPcmStreamer } from './pcmStreamer';

// FORCE LEGACY MODE: AudioWorklet is proving unstable in this environment.
// Falling back to ScriptProcessorNode ensures audio frames are captured reliably.
export async function createPcmStreamer(stream, options = {}) {
  // eslint-disable-next-line no-console
  console.log('[Audio] Forcing legacy ScriptProcessor streamer for reliability');
  
  return createLegacyPcmStreamer(stream, {
    onFrame: options.onFrame,
    targetSampleRate: options.targetSampleRate || 16000,
    audioContext: options.audioContext,
  });
}
